import { API_URL } from '../services/api';

const LEGACY_HOSTS = [
  'http://164.92.202.73:3000',
  'https://164.92.202.73:3000',
  'http://164.92.202.73',
  'http://localhost:3000',
  'https://localhost:3000',
];

export function resolveImageUrl(url) {
  if (!url) return url;

  let resolved = url.trim();

  if (resolved.startsWith('/')) {
    return `${API_URL}${resolved}`;
  }

  if (!resolved.startsWith('http')) {
    return `${API_URL}/${resolved.replace(/^\//, '')}`;
  }

  for (const legacy of LEGACY_HOSTS) {
    if (resolved.startsWith(legacy)) {
      resolved = `${API_URL}${resolved.slice(legacy.length)}`;
      break;
    }
  }

  if (resolved.startsWith('http://waslkapi.mahermalhem.site')) {
    resolved = resolved.replace('http://', 'https://');
  }
  console.log(resolved,"resolved");
  return resolved;
}
